import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { priorityEnum } from '@modules/tasks/_tasksEnums';

export const tasksGridColumns = [
  { label: 'Název', field: 'name', type: ColumnType.TEXT, width: 80 },
  { label: 'Zadání', field: 'instructions', type: ColumnType.TEXT, width: 80 },
  { label: 'Popis řešení', field: 'solutionDescription', type: ColumnType.TEXT, width: 80 },
  {
    label: 'Události',
    field: 'events',
    mapper: (es = []) => es.map(e => get(e, 'number')).join(', '),
    type: ColumnType.TEXT,
    width: 120
  },
  {
    label: 'Přestupky',
    field: 'delicts',
    mapper: (ds = []) => ds.map(d => get(d, 'number')).join(', '),
    type: ColumnType.TEXT,
    width: 120
  },
  {
    label: 'Vozidlo',
    field: 'serviceVehicle.fullName',
    displayField: 'serviceVehicle',
    mapper: o => get(o, 'fullName'),
    type: ColumnType.TEXT,
    width: 80
  },
  {
    label: 'Vytvořil',
    field: 'author',
    displayField: 'author',
    mapper: o => get(o, 'fullName'),
    type: ColumnType.TEXT,
    width: 80
  },
  {
    label: 'Priorita',
    field: 'priority.id',
    displayField: 'priority',
    type: ColumnType.ENUM,
    enum: priorityEnum,
    width: 80
  },
  {
    label: 'Stav',
    field: 'type.name',
    displayField: 'type',
    mapper: o => get(o, 'name'),
    type: ColumnType.TEXT,
    width: 80
  },
  { label: 'Datum od', field: 'startDate', type: ColumnType.DATE, width: 80 },
  { label: 'Datum do', field: 'endDate', type: ColumnType.DATE, width: 80 }
];

export const tasksFormHistoriesGridColumns = [
  {
    label: 'Strážník',
    field: 'employee',
    displayField: 'employee',
    mapper: o => get(o, 'fullName'),
    type: ColumnType.TEXT,
    width: 80
  },
  { label: 'Datum', field: 'created', type: ColumnType.DATE, width: 80 },
  { label: 'Operace', field: 'operation', type: ColumnType.TEXT, width: 80 }
];

export const tasksFormOfficersGridColumns = [
  { label: 'Strážník', field: 'fullName', type: ColumnType.TEXT, width: 80 }
];



// WEBPACK FOOTER //
// ./src/modules/tasks/_tasksColumns.ts